<template>
    <div
        v-loading="loading"
        class="hts-card"
        :class="extendClass">
        <div
            class="h-full card card-compact shadow border"
            :class="cClass">
            <figure v-if="bgImage">
                <img
                    :src="bgImage"
                    alt="image" >
            </figure>
            <div class="card-body">
                <h2 class="card-title">
                    <slot name="title">
                        <span
                            v-if="title"
                            class="label">
                            {{ title }}
                        </span>
                    </slot>
                </h2>
                <slot />
                <div class="card-actions justify-end">
                    <slot name="actions" />
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="ts" setup>
const props = defineProps({
  title: String,
  bgImage: String,
  noPadding: Boolean,
  extendClass: String,
  loading: Boolean,
  color: String
})
const { bgImage, noPadding, extendClass, color } = toRefs(props)

const cClass = computed(() => {
  const data = {
    'no-padding': noPadding?.value,
    'image-full': !!(bgImage && bgImage.value)
  } as { [key: string]: any }
  if (color?.value) {
    data[`border-${color.value}-500`] = true
  }
  return data
})
</script>
